import { getFarmSc } from 'helpers/mvx/loader';
import { proxyNetworkProvider, resultsParser } from '..';
import { getMinLiqEarningTreshold } from './getMinLiqEarningTreshold';
import { getVEGLDBalance } from '../mvx/getTokenBalance';
import { getSwapContractAddress } from 'helpers/mvx/formatters';

export const getFarmParameters = async (address: string) => {
  // const min_vegld_liquidity_treshold = await getMinLiqEarningTreshold(address);
  const swap_pool_address = getSwapContractAddress(address);
  const vegld_balance = await getVEGLDBalance(swap_pool_address);

  const farmContract = getFarmSc(address);
  const query = farmContract.methods
    .getFarmParameters([address])
    .check()
    .buildQuery();
  const response = await proxyNetworkProvider.queryContract(query);
  const { firstValue, returnCode } = resultsParser.parseQueryResponse(
    response,
    farmContract.getEndpoint('getFarmParameters')
  );
  if (!returnCode.isSuccess()) {
    return null;
  } else {
    return parseResult(firstValue?.valueOf(), vegld_balance);
  }
};

const parseResult = (
  value: any,
  vegld_balance: string
): FarmParameters | null => {
  return {
    is_tier_x: value.is_tier_x,
    diamond_multiplier: value.diamond_multiplier.toString(),
    tier_multiplier: value.tier_multiplier.toString(),
    pool_weight: value.pool_weight.toString(),
    liquidity_multiplier: value.liquidity_multiplier.toString(),
    personal_multiplier: value.personal_multiplier.toString(),
    density_multiplier: value.density_multiplier.toString(),
    total_multiplier: value.total_multiplier.toString(),
    vegld_balance
  };
};

export interface FarmParameters {
  is_tier_x: boolean;
  diamond_multiplier: string;
  tier_multiplier: string;
  pool_weight: string;
  liquidity_multiplier: string;
  personal_multiplier: string;
  density_multiplier: string;
  total_multiplier: string;
  vegld_balance: string;
}
